import { Box } from "@mui/material";
import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";

export interface BulkSelectionFooterProps {
    isDeleteMode: boolean;
    onCloseClick: () => void;
    onDeleteClick: () => void;
    deleteDisabled: boolean;
    deleteText: string;
}

/** The buttons beneath a list in bulk mode: Close, and in delete mode the button that deletes the selection. */
function BulkSelectionFooter(props: BulkSelectionFooterProps) {
    const { translateString } = useTranslation();

    return (
        <Box sx={{ display: "flex", justifyContent: "end", mt: 2, gap: 1 }}>
            <DotLegalButton buttonType="secondary" onClick={props.onCloseClick}>
                {translateString("close")}
            </DotLegalButton>
            {props.isDeleteMode && (
                <DotLegalButton buttonType="danger" onClick={props.onDeleteClick} disabled={props.deleteDisabled}>
                    {props.deleteText}
                </DotLegalButton>
            )}
        </Box>
    );
}

export default BulkSelectionFooter;
